// extracted by mini-css-extract-plugin
export default {"form":"BlackhatMonitoringFilters_form__CxKxf","field":"BlackhatMonitoringFilters_field__p7YNo"};